import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
const IsClientCtx = createContext(false);
export const IsClientCtxProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [isClient, setIsClient] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsClient(true);
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== children || $[3] !== isClient) {
    t3 = <IsClientCtx.Provider value={isClient}>{children}</IsClientCtx.Provider>;
    $[2] = children;
    $[3] = isClient;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export function useIsClient() {
  return useContext(IsClientCtx);
}